var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconNextUnreadLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconNextUnread",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M0 373.397v1386.667h1706.667v-803.2H1600v602.56l-305.6-366.827-82.027 68.267 327.04 392.533H167.253l327.04-392.533-82.026-68.267-305.6 366.827v-897.6l746.666 690.88 490.56-453.76-72.32-78.4-418.24 386.773-746.666-690.88v-36.373H1123.2V373.397H0Zm1383.957-129.525c63.147-57.707 145.494-87.36 230.294-83.52 85.333 3.84 164.16 40.64 221.866 103.68 57.707 63.04 87.36 144.853 83.52 230.293-3.733 85.334-40.533 164.16-103.68 221.867-59.413 54.4-135.573 83.84-215.573 83.84-4.907 0-9.707-.107-14.613-.32-85.44-3.84-164.16-40.64-221.867-103.68-57.707-63.04-87.36-144.853-83.627-230.293 3.84-85.334 40.64-164.16 103.68-221.867Zm215.787 22.827c-53.333 0-104.107 19.626-143.68 55.893-42.133 38.507-66.667 90.987-69.227 147.947-2.56 56.96 17.28 111.36 55.68 153.493 38.507 42.027 91.094 66.56 148.054 69.12 56.853 2.88 111.36-17.28 153.386-55.68 42.134-38.507 66.667-91.093 69.12-147.947 2.56-56.96-17.173-111.466-55.68-153.493-38.4-42.027-90.986-66.56-147.946-69.12-3.2-.213-6.4-.213-9.707-.213Z",
      fillRule: "evenodd"
    })));
  }
}
IconNextUnreadLine.glyphName = 'next-unread';
IconNextUnreadLine.variant = 'Line';
IconNextUnreadLine.displayName = 'IconNextUnreadLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconNextUnreadLine.propTypes = {
  ...SVGIcon.propTypes
};
IconNextUnreadLine.allowedProps = [...SVGIcon.allowedProps];
export default IconNextUnreadLine;
export { IconNextUnreadLine };